<template lang="pug">
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") На Вашем аккаунте закончились средства {{ item.info.blockedAt }}. Все файлы проекта будут храниться в течение 90 дней (до {{ item.info.willBeDeletedAt }}) после блокировки, после чего они могут быть удалены автоматически. Не забудьте пополнить баланс, чтобы вернуться к работе в системе.
</template>

<script>
export default {
  name: 'NotificationLowBalance',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
